import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Layout } from "./components/layout/Layout";

// Public Pages
import { Home } from "./pages/Home";
import { Buyers } from "./pages/Buyers";
import { Sellers } from "./pages/Sellers";
import { Investors } from "./pages/Investors";
import { Financing } from "./pages/Financing";
import { PropertyManagement } from "./pages/PropertyManagement";
import { OpenHouses } from "./pages/OpenHouses";
import { Team } from "./pages/Team";
import { JoinTeam } from "./pages/JoinTeam";
import { NotaryServices } from "./pages/NotaryServices";
import { Resources } from "./pages/Resources";
import { Contact } from "./pages/Contact";

// Admin Pages
import { AdminLogin } from "./pages/admin/AdminLogin";
import { AdminDashboard } from "./pages/admin/AdminDashboard";
import { AdminLeads } from "./pages/admin/AdminLeads";
import { AdminTeam } from "./pages/admin/AdminTeam";
import { AdminProperties } from "./pages/admin/AdminProperties";
import { AdminOpenHouses } from "./pages/admin/AdminOpenHouses";
import { AdminApplications } from "./pages/admin/AdminApplications";
import { AdminAutomations } from "./pages/admin/AdminAutomations";
import { AdminAgents } from "./pages/admin/AdminAgents";
import { AdminAppointments } from "./pages/admin/AdminAppointments";
import { AdminActivities } from "./pages/admin/AdminActivities";
import { AdminHelp } from "./pages/admin/AdminHelp";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/buyers" element={<Layout><Buyers /></Layout>} />
          <Route path="/sellers" element={<Layout><Sellers /></Layout>} />
          <Route path="/investors" element={<Layout><Investors /></Layout>} />
          <Route path="/financing" element={<Layout><Financing /></Layout>} />
          <Route path="/property-management" element={<Layout><PropertyManagement /></Layout>} />
          <Route path="/open-houses" element={<Layout><OpenHouses /></Layout>} />
          <Route path="/team" element={<Layout><Team /></Layout>} />
          <Route path="/join" element={<Layout><JoinTeam /></Layout>} />
          <Route path="/notary" element={<Layout><NotaryServices /></Layout>} />
          <Route path="/resources" element={<Layout><Resources /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
          <Route path="/admin/team" element={<AdminTeam />} />
          <Route path="/admin/properties" element={<AdminProperties />} />
          <Route path="/admin/open-houses" element={<AdminOpenHouses />} />
          <Route path="/admin/applications" element={<AdminApplications />} />
          <Route path="/admin/automations" element={<AdminAutomations />} />
          <Route path="/admin/agents" element={<AdminAgents />} />
          <Route path="/admin/appointments" element={<AdminAppointments />} />
          <Route path="/admin/activities" element={<AdminActivities />} />
          <Route path="/admin/help" element={<AdminHelp />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
